<template>
  <div>
    <PageTitle title="Edit Service" :backBtn="true" :showLoading="isLoading" />
    <v-container fluid class="lighten-12">
      <ValidationObserver ref="observer">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>General</v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Service name"
                          rules="required"
                          vid="name"
                        >
                          <v-text-field
                            outlined
                            v-model="Service.name"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="Name"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          name="Code"
                          rules="required"
                          v-slot="{ errors }"
                          vid="code"
                        >
                          <v-text-field
                            v-model="Service.code"
                            :error-messages="errors"
                            outlined
                            dense
                            hide-details="auto"
                            label="Code"
                            required
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          name="Amount"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="Service.amount"
                            :error-messages="errors"
                            outlined
                            dense
                            hide-details="auto"
                            label="Amount"
                            required
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Category"
                          rules="required"
                        >
                          <treeselect
                            outlined
                            :error-messages="errors"
                            required
                            class="tree-border"
                            dense
                            v-model="Service.productCategory.id"
                            filled
                            :options="categories"
                            placeholder="Category"
                            @select="onSelectCategory"
                          >
                            <label
                              slot="option-label"
                              slot-scope="{
                                node,
                                shouldShowCount,
                                count,
                                labelClassName,
                                countClassName,
                              }"
                              :class="labelClassName"
                            >
                              {{ node.raw.label }}
                              <span
                                v-if="shouldShowCount"
                                :class="countClassName"
                                >({{ count }})</span
                              >
                            </label>
                          </treeselect>
                          <span
                            class="error-message"
                            v-if="categoryError != ''"
                          >
                            {{ categoryError }}</span
                          >
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>Note</v-card-title>

                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-textarea
                          rows="3"
                          outlined
                          v-model="Service.remarks"
                          hide-details
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                  <v-container>
                    <FileUpload
                      title="Image"
                      @isImageUpdated="onChangeImageUpload"
                      :multiple="false"
                      v-model="selectedImages"
                      size="2048"
                      ref="imageInput"
                      :types="['jpeg', 'png', 'jpg']"
                      :showPreview="true"
                      :externalFiles="Service.image ? [Service.image] : []"
                      :camera="true"
                    />
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-col cols="12" class="text-right pa-0">
          <v-btn
            depressed
            small
            class="ml-1 text-white btn_medium"
            @click="clear"
            >Clear</v-btn
          >
          <v-btn
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            @click="submit"
            >Update</v-btn
          >
        </v-col>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { required, email, max } from 'vee-validate/dist/rules';
import FileUpload from '@/components/base/FileUpload';
import { Service } from '../../../models/Service';
import { ServiceEntity } from '../../../models/EntityModels/ServiceEntity';
import axios from '@/plugins/axios';
import { ServiceViewModel } from '../../../models/View Models/ServiceViewModel';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { ProductCategory } from '../../../models/ProductCategory';

// import the component
import Treeselect from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

setInteractionMode('eager');

// Mixins
// import Categories from "@/mixins/Categories";

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Treeselect,
    FileUpload,
  },
  data: () => ({
    imageUpdated: null,
    cameraEnabled: false,
    isUnitValid: false,
    clickSubmit: false,
    loadingBrand: false,
    Service: new Service(),
    errors: [],
    messages: [],
    suppliers: [],
    productCategory: [new ProductCategory()],
    selectedSuppliers: [],
    isLoading: false,
    tab: 'Credit',
    selectedImages: '',
    isDisabledSubmit: false,
    categories: [],
    photo: null,
    isClickedClear: false,
    searchCategory: null,
    categoryError: '',
  }),
  created() {
    this.GetProductCategoriesByQuery();
    this.GetService();
  },
  computed: {
    ...mapState(['productpagesize']),
  },
  methods: {
    onSelectCategory(value) {
      this.categoryError = '';
    },
    onChangeImageUpload(value) {
      this.imageUpdated = value;
    },

    async submit() {
      this.clickSubmit = true;
      const isValid = await this.$refs.observer.validate();
      let validCategory =
        this.Service.productCategory && this.Service.productCategory.id != null;
      if (!validCategory) {
        this.categoryError = 'Category is required';
      } else {
        this.categoryError = '';
      }
      if (validCategory && isValid && this.Service) {
        this.UpdateService();
      } else {
        this.clickSubmit = false;
      }
    },

    clear() {
      this.isClickedClear = false;
      this.isClickedClear = true;
      this.Service = [];
      this.selectedImages = [];
      this.Service.productCategory = {
        id: null,
        name: null,
      };
      this.$refs.fileUpload.removeItem(0);
      this.$refs.observer.reset();
    },
    UpdateService() {
      this.isLoading = false;
      this.isDisabledSubmit = true;
      const credentials = new ServiceEntity(this.Service);

      const Id = credentials.id;
      delete credentials.id;
      axios
        .patch(`services/${Id}`, credentials)
        .then(async (res) => {
          this.succeeed = true;

          if (this.selectedImages) {
            await this.UploadServiceImage(Id)
              .then(() => {
                this.isDisabledSubmit = false;
                this.isLoading = false;
              })
              .catch(() => {
                this.$toast.error('Service image uploading failed');
                this.isDisabledSubmit = false;
                this.isLoading = false;
              });
          }
          this.$toast.success('Service updated successfully.');
          this.$router.push('?page=' + this.productpagesize);
          this.$router.push('/service');
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.error) {
            this.$refs.observer.setErrors(err.response.data.error);
          }
          this.$toast.error(
            err.response?.data?.title || 'Failed to update service',
          );
          this.messages = err.response?.data?.title || '';
          this.isDisabledSubmit = false;
          this.isLoading = false;
        });
    },
    async UploadServiceImage(serviceId) {
      let fromData = new FormData();
      if (this.selectedImages && this.imageUpdated) {
        fromData.append('id', serviceId);
        fromData.append('image', this.selectedImages);
        return await axios.post(`services/${serviceId}/image-upload`, fromData);
      } else if (this.imageUpdated == false) {
        fromData.append('id', serviceId);
        fromData.append('image', null);
        return await axios.post(`services/${serviceId}/image-upload`, fromData);
      } else {
        return true;
      }
    },

    GetProductCategoriesByQuery(query = '') {
      this.$store
        .dispatch('product/GetProductCategoriesWithChild', {
          query: query.searchQuery,
        })
        .then((res) => {
          this.categories = res.data;
        })
        .catch((err) => {});
    },
    GetService() {
      let Id = this.$route.params.id;
      axios
        .get(`services/${Id}`)
        .then((res) => {
          this.$refs.imageInput.GetImage();

          this.Service = new ServiceViewModel(res.data);
          {
            this.Service.image = this.Service.image + '?t=' + Date.now();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
  },

  watch: {
    searchCategory: {
      handler(val) {
        this.GetProductCategoriesByQuery(val);
      },
      deep: true,
    },
  },
};
</script>
